// Curated ingredient image map - keyword → Unsplash CDN URL
export const INGREDIENT_IMAGE_MAP = {
  // Vegetables / Verduras
  "tomate": "https://images.unsplash.com/photo-1758221055278-cfff8d83b091?w=100&h=100&fit=crop&auto=format&q=70",
  "aguacate": "https://images.unsplash.com/photo-1757332914587-6d3e174e0e19?w=100&h=100&fit=crop&auto=format&q=70",
  "avocado": "https://images.unsplash.com/photo-1757332914587-6d3e174e0e19?w=100&h=100&fit=crop&auto=format&q=70",
  "ajo": "https://images.unsplash.com/photo-1760445529922-ca58ca23c3a7?w=100&h=100&fit=crop&auto=format&q=70",
  "garlic": "https://images.unsplash.com/photo-1760445529922-ca58ca23c3a7?w=100&h=100&fit=crop&auto=format&q=70",
  "cebolla": "https://images.unsplash.com/photo-1662825173108-9856d2cc76e5?w=100&h=100&fit=crop&auto=format&q=70",
  "onion": "https://images.unsplash.com/photo-1662825173108-9856d2cc76e5?w=100&h=100&fit=crop&auto=format&q=70",
  "pimiento": "https://images.unsplash.com/photo-1563565375-f3fdfdbefa83?w=100&h=100&fit=crop&auto=format&q=70",
  "pepper": "https://images.unsplash.com/photo-1563565375-f3fdfdbefa83?w=100&h=100&fit=crop&auto=format&q=70",
  "aji": "https://images.unsplash.com/photo-1563565375-f3fdfdbefa83?w=100&h=100&fit=crop&auto=format&q=70",
  "patata": "https://images.unsplash.com/photo-1518977676601-b53f82aba655?w=100&h=100&fit=crop&auto=format&q=70",
  "papa": "https://images.unsplash.com/photo-1518977676601-b53f82aba655?w=100&h=100&fit=crop&auto=format&q=70",
  "potato": "https://images.unsplash.com/photo-1518977676601-b53f82aba655?w=100&h=100&fit=crop&auto=format&q=70",
  "zanahoria": "https://images.unsplash.com/photo-1590868309235-ea34bed7bd7f?w=100&h=100&fit=crop&auto=format&q=70",
  "carrot": "https://images.unsplash.com/photo-1590868309235-ea34bed7bd7f?w=100&h=100&fit=crop&auto=format&q=70",
  "lechuga": "https://images.unsplash.com/photo-1556801712-76c8eb07bbc9?w=100&h=100&fit=crop&auto=format&q=70",
  "espinaca": "https://images.unsplash.com/photo-1576045057995-568f588f82fb?w=100&h=100&fit=crop&auto=format&q=70",
  "limon": "https://images.unsplash.com/photo-1587840171670-8b850147754e?w=100&h=100&fit=crop&auto=format&q=70",
  "lemon": "https://images.unsplash.com/photo-1587840171670-8b850147754e?w=100&h=100&fit=crop&auto=format&q=70",
  "naranja": "https://images.unsplash.com/photo-1547514701-42782101795e?w=100&h=100&fit=crop&auto=format&q=70",
  "orange": "https://images.unsplash.com/photo-1547514701-42782101795e?w=100&h=100&fit=crop&auto=format&q=70",
  "setas": "https://images.unsplash.com/photo-1518977956812-cd3dbadaaf31?w=100&h=100&fit=crop&auto=format&q=70",
  "champiñon": "https://images.unsplash.com/photo-1518977956812-cd3dbadaaf31?w=100&h=100&fit=crop&auto=format&q=70",
  "mushroom": "https://images.unsplash.com/photo-1518977956812-cd3dbadaaf31?w=100&h=100&fit=crop&auto=format&q=70",
  // Proteins / Proteínas
  "pollo": "https://images.unsplash.com/photo-1642497394469-188b0f4bcae6?w=100&h=100&fit=crop&auto=format&q=70",
  "chicken": "https://images.unsplash.com/photo-1642497394469-188b0f4bcae6?w=100&h=100&fit=crop&auto=format&q=70",
  "ternera": "https://images.unsplash.com/photo-1690983322025-aab4f95a0269?w=100&h=100&fit=crop&auto=format&q=70",
  "solomillo": "https://images.unsplash.com/photo-1690983322025-aab4f95a0269?w=100&h=100&fit=crop&auto=format&q=70",
  "entrecot": "https://images.unsplash.com/photo-1690983322025-aab4f95a0269?w=100&h=100&fit=crop&auto=format&q=70",
  "carne": "https://images.unsplash.com/photo-1690983322025-aab4f95a0269?w=100&h=100&fit=crop&auto=format&q=70",
  "beef": "https://images.unsplash.com/photo-1690983322025-aab4f95a0269?w=100&h=100&fit=crop&auto=format&q=70",
  "cerdo": "https://images.unsplash.com/photo-1606923829579-0cb981a83e2e?w=100&h=100&fit=crop&auto=format&q=70",
  "pork": "https://images.unsplash.com/photo-1606923829579-0cb981a83e2e?w=100&h=100&fit=crop&auto=format&q=70",
  "merluza": "https://images.unsplash.com/photo-1772285253181-b1257afb3698?w=100&h=100&fit=crop&auto=format&q=70",
  "salmon": "https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?w=100&h=100&fit=crop&auto=format&q=70",
  "pescado": "https://images.unsplash.com/photo-1772285253181-b1257afb3698?w=100&h=100&fit=crop&auto=format&q=70",
  "fish": "https://images.unsplash.com/photo-1772285253181-b1257afb3698?w=100&h=100&fit=crop&auto=format&q=70",
  "gambas": "https://images.unsplash.com/photo-1756364084889-9a8d9ece6112?w=100&h=100&fit=crop&auto=format&q=70",
  "langostino": "https://images.unsplash.com/photo-1756364084889-9a8d9ece6112?w=100&h=100&fit=crop&auto=format&q=70",
  "shrimp": "https://images.unsplash.com/photo-1756364084889-9a8d9ece6112?w=100&h=100&fit=crop&auto=format&q=70",
  "atun": "https://images.unsplash.com/photo-1509424741098-a61af6a0d88c?w=100&h=100&fit=crop&auto=format&q=70",
  "jamon": "https://images.unsplash.com/photo-1607116667981-ff23c7df3b9f?w=100&h=100&fit=crop&auto=format&q=70",
  "ham": "https://images.unsplash.com/photo-1607116667981-ff23c7df3b9f?w=100&h=100&fit=crop&auto=format&q=70",
  "chorizo": "https://images.unsplash.com/photo-1607116667981-ff23c7df3b9f?w=100&h=100&fit=crop&auto=format&q=70",
  // Dairy / Lácteos
  "huevo": "https://images.unsplash.com/photo-1759082495730-2a5090278e7e?w=100&h=100&fit=crop&auto=format&q=70",
  "egg": "https://images.unsplash.com/photo-1759082495730-2a5090278e7e?w=100&h=100&fit=crop&auto=format&q=70",
  "leche": "https://images.unsplash.com/photo-1552767057-0316d96a96c4?w=100&h=100&fit=crop&auto=format&q=70",
  "milk": "https://images.unsplash.com/photo-1552767057-0316d96a96c4?w=100&h=100&fit=crop&auto=format&q=70",
  "queso": "https://images.unsplash.com/photo-1757857755327-5b38c51a0302?w=100&h=100&fit=crop&auto=format&q=70",
  "cheese": "https://images.unsplash.com/photo-1757857755327-5b38c51a0302?w=100&h=100&fit=crop&auto=format&q=70",
  "mantequilla": "https://images.unsplash.com/photo-1589985270826-4b7bb135bc9d?w=100&h=100&fit=crop&auto=format&q=70",
  "butter": "https://images.unsplash.com/photo-1589985270826-4b7bb135bc9d?w=100&h=100&fit=crop&auto=format&q=70",
  "nata": "https://images.unsplash.com/photo-1550583724-b2692b85b150?w=100&h=100&fit=crop&auto=format&q=70",
  "cream": "https://images.unsplash.com/photo-1550583724-b2692b85b150?w=100&h=100&fit=crop&auto=format&q=70",
  "yogur": "https://images.unsplash.com/photo-1488477181946-6428a0291777?w=100&h=100&fit=crop&auto=format&q=70",
  // Grains & Baking
  "arroz": "https://images.unsplash.com/photo-1743674452796-ad8d0cf38005?w=100&h=100&fit=crop&auto=format&q=70",
  "rice": "https://images.unsplash.com/photo-1743674452796-ad8d0cf38005?w=100&h=100&fit=crop&auto=format&q=70",
  "harina": "https://images.unsplash.com/photo-1603569283847-aa295f0d016a?w=100&h=100&fit=crop&auto=format&q=70",
  "flour": "https://images.unsplash.com/photo-1603569283847-aa295f0d016a?w=100&h=100&fit=crop&auto=format&q=70",
  "pasta": "https://images.unsplash.com/photo-1473093226555-0e8d9e2dc3fc?w=100&h=100&fit=crop&auto=format&q=70",
  "pan": "https://images.unsplash.com/photo-1732565674273-44e3ba2823bc?w=100&h=100&fit=crop&auto=format&q=70",
  "bread": "https://images.unsplash.com/photo-1732565674273-44e3ba2823bc?w=100&h=100&fit=crop&auto=format&q=70",
  "azucar": "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=100&h=100&fit=crop&auto=format&q=70",
  "sugar": "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=100&h=100&fit=crop&auto=format&q=70",
  "chocolate": "https://images.unsplash.com/photo-1481391319762-47dff72954d9?w=100&h=100&fit=crop&auto=format&q=70",
  // Oils & Condiments
  "aceite": "https://images.unsplash.com/photo-1757801333112-7b89af15c7fe?w=100&h=100&fit=crop&auto=format&q=70",
  "oil": "https://images.unsplash.com/photo-1757801333112-7b89af15c7fe?w=100&h=100&fit=crop&auto=format&q=70",
  "vinagre": "https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?w=100&h=100&fit=crop&auto=format&q=70",
  "sal": "https://images.unsplash.com/photo-1626107780982-2b3f53cdb617?w=100&h=100&fit=crop&auto=format&q=70",
  "salt": "https://images.unsplash.com/photo-1626107780982-2b3f53cdb617?w=100&h=100&fit=crop&auto=format&q=70",
  "pimienta": "https://images.unsplash.com/photo-1615485290382-441e4520a5f9?w=100&h=100&fit=crop&auto=format&q=70",
  "pepper spice": "https://images.unsplash.com/photo-1615485290382-441e4520a5f9?w=100&h=100&fit=crop&auto=format&q=70",
  // Beverages
  "vino": "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?w=100&h=100&fit=crop&auto=format&q=70",
  "wine": "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?w=100&h=100&fit=crop&auto=format&q=70",
  "cerveza": "https://images.unsplash.com/photo-1608270586620-248524c67de9?w=100&h=100&fit=crop&auto=format&q=70",
  "beer": "https://images.unsplash.com/photo-1608270586620-248524c67de9?w=100&h=100&fit=crop&auto=format&q=70",
  "agua": "https://images.unsplash.com/photo-1548839140-29a749e1cf4d?w=100&h=100&fit=crop&auto=format&q=70",
  "cafe": "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=100&h=100&fit=crop&auto=format&q=70",
  "coffee": "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=100&h=100&fit=crop&auto=format&q=70",
  // Extra Spanish
  "calamares": "https://images.unsplash.com/photo-1565680018434-b513d5e5fd47?w=100&h=100&fit=crop&auto=format&q=70",
  "calamar": "https://images.unsplash.com/photo-1565680018434-b513d5e5fd47?w=100&h=100&fit=crop&auto=format&q=70",
  "mejillones": "https://images.unsplash.com/photo-1534482421-64566f976cfa?w=100&h=100&fit=crop&auto=format&q=70",
  "almejas": "https://images.unsplash.com/photo-1534482421-64566f976cfa?w=100&h=100&fit=crop&auto=format&q=70",
  "marisco": "https://images.unsplash.com/photo-1534482421-64566f976cfa?w=100&h=100&fit=crop&auto=format&q=70",
  "pimenton": "https://images.unsplash.com/photo-1563565375-f3fdfdbefa83?w=100&h=100&fit=crop&auto=format&q=70",
  "azafran": "https://images.unsplash.com/photo-1615485290382-441e4520a5f9?w=100&h=100&fit=crop&auto=format&q=70",
  "hierbas": "https://images.unsplash.com/photo-1615485290382-441e4520a5f9?w=100&h=100&fit=crop&auto=format&q=70",
  "albahaca": "https://images.unsplash.com/photo-1576045057995-568f588f82fb?w=100&h=100&fit=crop&auto=format&q=70",
  "perejil": "https://images.unsplash.com/photo-1576045057995-568f588f82fb?w=100&h=100&fit=crop&auto=format&q=70",
  "cilantro": "https://images.unsplash.com/photo-1576045057995-568f588f82fb?w=100&h=100&fit=crop&auto=format&q=70",
  "mango": "https://images.unsplash.com/photo-1590502593747-42a996133562?w=100&h=100&fit=crop&auto=format&q=70",
  "platano": "https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?w=100&h=100&fit=crop&auto=format&q=70",
  "banana": "https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?w=100&h=100&fit=crop&auto=format&q=70",
  "harina de maiz": "https://images.unsplash.com/photo-1603569283847-aa295f0d016a?w=100&h=100&fit=crop&auto=format&q=70",
  "maiz": "https://images.unsplash.com/photo-1551754655-cd27e38d2076?w=100&h=100&fit=crop&auto=format&q=70",
  "frijol": "https://images.unsplash.com/photo-1568702846914-96b305d2aaeb?w=100&h=100&fit=crop&auto=format&q=70",
  "caraotas": "https://images.unsplash.com/photo-1568702846914-96b305d2aaeb?w=100&h=100&fit=crop&auto=format&q=70",
  "lentejas": "https://images.unsplash.com/photo-1568702846914-96b305d2aaeb?w=100&h=100&fit=crop&auto=format&q=70",
  "garbanzo": "https://images.unsplash.com/photo-1568702846914-96b305d2aaeb?w=100&h=100&fit=crop&auto=format&q=70",
};

// Unit conversion for merging ingredients
export const UNIT_CONVERSIONS = {
  g:  { base: "kg", factor: 0.001 },
  kg: { base: "kg", factor: 1 },
  ml: { base: "l",  factor: 0.001 },
  l:  { base: "l",  factor: 1 },
};

export function toBase(ing) {
  const conv = UNIT_CONVERSIONS[ing.unit];
  if (!conv) return null;
  return {
    stock: ing.current_stock * conv.factor,
    cost:  ing.cost_per_unit  / conv.factor,
    base:  conv.base,
  };
}

export function getIngredientDisplayImage(ingredient) {
  if (ingredient.image_url) return ingredient.image_url;
  if (ingredient.has_image) return "__lazy__";
  const name = ingredient.name
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  for (const [keyword, url] of Object.entries(INGREDIENT_IMAGE_MAP)) {
    if (name.includes(keyword)) return url;
  }
  return null;
}

// Common OCR/invoice noise words that distort matching. Anything not listed
// here stays as a token (e.g. "cherry" in "Tomate cherry" is signal, not noise).
const _MATCH_STOPWORDS = new Set([
  "kg", "g", "gr", "grs", "ml", "l", "lt", "lts", "cl",
  "ud", "uds", "und", "unds", "unidad", "unidades",
  "pack", "packs", "caja", "cajas", "bolsa", "bolsas", "bote", "botes",
  "lata", "latas", "botella", "botellas",
  "de", "del", "la", "el", "los", "las", "al",
  "x", "por",
]);

function _normalizeForMatch(s) {
  return (s || "")
    .toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")  // strip accents
    .replace(/[^a-z0-9\s]/g, " ")                       // punctuation → space
    .replace(/\b\d+[.,]?\d*\s*(kg|g|gr|ml|l|cl|ud|uds)\b/g, " ") // "1,5kg" etc.
    .replace(/\s+/g, " ")
    .trim();
}

function _tokenize(s) {
  return _normalizeForMatch(s)
    .split(" ")
    .filter(t => t.length > 1 && !_MATCH_STOPWORDS.has(t));
}

/**
 * Fuzzy match an invoice item name against existing ingredients.
 *
 * Strategy (stops at first successful tier):
 *   1) Exact normalized match (accent-insensitive, noise-stripped)
 *   2) One contains the other as a substring (after normalization)
 *   3) Token overlap score ≥ 0.5 (Jaccard-like) → highest scorer wins
 *
 * This fixes the "no está fusionando" bug where invoice lines like
 * "TOMATE CHERRY RAMA KG" wouldn't merge into an existing "Tomate cherry".
 */
export function findBestMatch(itemName, ingList) {
  if (!itemName || !Array.isArray(ingList) || ingList.length === 0) return null;

  const itemNorm = _normalizeForMatch(itemName);
  if (!itemNorm) return null;

  // Tier 1: exact normalized match
  const exact = ingList.find(i => _normalizeForMatch(i.name) === itemNorm);
  if (exact) return exact;

  // Tier 2: substring either way (handles "tomate cherry" vs "tomate cherry rama")
  const substr = ingList.find(i => {
    const n = _normalizeForMatch(i.name);
    return n.length > 2 && (n.includes(itemNorm) || itemNorm.includes(n));
  });
  if (substr) return substr;

  // Tier 3: token overlap (Jaccard-like) with minimum 0.5 and ≥2 shared tokens
  const itemTokens = new Set(_tokenize(itemName));
  if (itemTokens.size === 0) return null;
  let best = null;
  let bestScore = 0;
  for (const ing of ingList) {
    const ingTokens = new Set(_tokenize(ing.name));
    if (ingTokens.size === 0) continue;
    let shared = 0;
    for (const t of itemTokens) if (ingTokens.has(t)) shared++;
    if (shared < 2 && Math.min(itemTokens.size, ingTokens.size) > 1) continue;
    const union = itemTokens.size + ingTokens.size - shared;
    const score = shared / union;
    if (score > bestScore && score >= 0.5) {
      bestScore = score;
      best = ing;
    }
  }
  return best;
}
